export { default } from './Excerpt';
